import { useSelector, shallowEqual } from 'react-redux'

import type { Recipe, RecipeUUID } from 'reducers/menu-recipes/recipes'
import { getOfferedRecipes } from 'selectors/menu-recipes/getOfferedRecipes'

/**
 * Returns offered recipes
 */
export const useOfferedRecipes = (): Record<RecipeUUID, Recipe> =>
  useSelector(getOfferedRecipes, shallowEqual)
